export default __webpack_public_path__ + "static/media/Background_00189.dacab2de.png";